import { render } from "./WritingAssistantComponent.vue?vue&type=template&id=ad7ea764&scoped=true"
import script from "./WritingAssistantComponent.vue?vue&type=script&lang=js"
export * from "./WritingAssistantComponent.vue?vue&type=script&lang=js"

import "./WritingAssistantComponent.vue?vue&type=style&index=0&id=ad7ea764&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad7ea764"]])

export default __exports__